function getPositiveId(value) {
  if (value === undefined || value === null || value === '') {
    return '';
  }

  const numberValue = Number(value);
  if (!Number.isFinite(numberValue) || numberValue <= 0) {
    return '';
  }

  return String(value);
}

function hasValidOptionSetting(setting) {
  return !!(setting && getPositiveId(setting.ID));
}

function normalizeOptionSettings(items) {
  if (!Array.isArray(items)) {
    return [];
  }

  return items.filter(hasValidOptionSetting);
}

function usesUsdtBalance(tabIndex, tradeType) {
  const numberTabIndex = Number(tabIndex);
  return numberTabIndex === 1 || numberTabIndex === 2 || tradeType === 'buy';
}

function createOptionSettingError() {
  const error = new Error('OPTION_SETTING_REQUIRED');
  error.code = 'OPTION_SETTING_REQUIRED';
  return error;
}

function buildOptionOrderFormData(options) {
  const {
    bitInfo,
    amount,
    upDownType,
    futuresObj,
    createFormData,
  } = options || {};

  const settingId = futuresObj && getPositiveId(futuresObj.ID);
  if (!settingId) {
    throw createOptionSettingError();
  }

  const form = createFormData ? createFormData() : new FormData();
  form.append('CurrencyId', bitInfo && bitInfo.ID);
  form.append('Amount', amount);
  form.append('Direction', upDownType == 1 ? 'rose' : 'fall');
  form.append('SettingId', settingId);

  return form;
}

module.exports = {
  buildOptionOrderFormData,
  hasValidOptionSetting,
  normalizeOptionSettings,
  usesUsdtBalance,
};
